import React from 'react';
import { useField, FieldConfig } from 'formik';
import useEventHandler from 'Hooks/useEventHandler';
import { GetFlatFilterFields } from 'Source/graphql/queries/getFlatFilterFields.generated';
import FilterFieldComboboxV3, { FieldFilterProp } from './FilterFieldComboboxV3';

export type FormikFieldFilterProp<T = string> = FieldFilterProp<T> & Pick<FieldConfig, 'name'>;

const FormikFilterFieldComboboxV3 = React.forwardRef<HTMLInputElement, FormikFieldFilterProp>(
  function FormikFilterFieldCombobox<T>(
    props: FormikFieldFilterProp<T>,
    ref: React.ForwardedRef<HTMLInputElement>,
  ): React.ReactElement {
    const { name, menuTitle, ...fieldProps } = props;
    const [field, , { setValue }] = useField({ name });
    const setFieldValue = useEventHandler(setValue);

    return (
      <FilterFieldComboboxV3
        menuTitle={menuTitle}
        data-tid="no-code-filter-target"
        // @ts-ignore - onSelect type mismatch between Formik setValue and AutoCompleteInput
        onSelect={(f: GetFlatFilterFields['flatFilterFields']['flatFields'][number]) =>
          setFieldValue(f.target)
        }
        ref={ref}
        {...fieldProps}
        {...field}
      />
    );
  },
);

export default FormikFilterFieldComboboxV3;
